<template>
  <el-dialog :title="title"
             :visible.sync="visible"
             width="800px"
             @close="handleClose">
    <el-form :model="form"
             ref="form"
             :rules="rules"
             label-width="150px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="合同号"
                        prop="contractNo">
            <el-input class="form-input"
                      :disabled='isEdit'
                      v-model="form.contractNo">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同类型"
                        prop="contractType">
            <el-input class="form-input"
                      :disabled='isEdit'
                      @change="contractTypeChange"
                      v-model="form.contractType">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="供应商名称"
                        prop="supplierName">
            <el-input class="form-input"
                      :disabled='isEdit'
                      v-model="form.supplierName">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="库房类型"
                        prop="storeroomType">
            <el-input class="form-input"
                      disabled
                      v-model="form.storeroomType">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="库房"
                        prop="storeroomCode">
            <el-select filterable
                       @change="changeStoreroom"
                       v-model="form.storeroomCode">
              <el-option v-for="item in LOV_CODE['storeHouseArr']"
                         :key="item.storeroomCode"
                         :label="item.storeroomName"
                         :value="item.storeroomCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="库房名称"
                        prop="storeroomName">
            <el-input class="form-input"
                      disabled
                      v-model="form.storeroomName">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
<!--        <el-col :span="12">
          <el-form-item label="状态"
                        prop="status">
            <el-select v-model="form.status"
                       placeholder="请选择状态">
              <el-option v-for="item in statusArr"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
        <el-col :span="12">
          <el-form-item label="料堆"
                        prop="oilTankCode">
            <el-select v-model="form.oilTankCode"
                       clearable
                       filterable
                       :disabled="this.form.contractType !== '销售' && this.form.contractType !== '调拨'"
                       @change="oilTankCodeChange">
              <el-option v-for="item in diaOilTankOptions"
                         :key="item.oilTankCode"
                         :label="item.oilTankCode"
                         :value="item.oilTankCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注"
                    prop="memo">
        <el-input type="textarea"
                  :rows="2"
                  v-model="form.memo"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'addOrEditDialog',
  props: [
    'show',
    'info',
    'LOV_CODE'
  ],
  components: {

  },
  data () {
    return {
      visible: false,
      form: {
      },
      rules: {},
      statusArr: [
        {
          value: '0',
          label: '未分配'
        },
        {
          value: '1',
          label: '已分配'
        }
      ],
      diaOilTankOptions: []
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑' : '新增'
    },
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    }
  },
  methods: {
    ...mapActions([
      'saveContractInfo',
      'getContractInfoList',
      'updateContractInfo',
      'getMaterialPileList'
    ]),
    handleClose () {
      this.$emit('update:show', false)
    },
    handleSubmit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const {
            contractNo,
            contractType,
            supplierName,
            storeroomType,
            storeroomCode,
            storeroomName,
            status,
            memo
          } = this.form
          let params = {
            contractNo,
            contractType,
            supplierName,
            storeroomType,
            storeroomCode,
            storeroomName,
            status,
            memo,
            pileName: this.form.oilTankCode
          }
          if (this.isEdit) {
            await this.updateContractInfo({ ...this.info, ...params })
          } else {
            await this.saveContractInfo(params)
          }
          this.getContractInfoList()
          this.handleClose()
        }
      })
    },
    changeStoreroom (val) {
      this.form.oilTankCode = ''
      let storeHouse = this.LOV_CODE.storeHouseArr.find(item => item.storeroomCode === val)
      this.form.storeroomCode = storeHouse.storeroomCode
      this.form.storeroomName = storeHouse.storeroomName
      this.form.storeroomType = storeHouse.storeroomType
      this.getMaterialPileList({ reservoirAreaCode: 'FLK', storeroomCode: val }).then((res) => {
        if (res) {
          const temp = res.map((item) => {
            return {
              oilTankCode: item.oilTankCode,
              oilTankName: item.oilTankName
            }
          })
          this.diaOilTankOptions = temp
        }
      })
    },
    oilTankCodeChange () {
      this.$forceUpdate()
    },
    contractTypeChange () {
      this.form.oilTankCode = ''
      this.form.oilTankName = ''
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = this.isEdit
          ? this.info
          : {
          }
        this.form.oilTankCode = this.info.pileName
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
      if (this.form.storeroomCode) {
        let storeHouse = this.LOV_CODE.storeHouseArr.find(item => item.storeroomCode === this.form.storeroomCode)
        this.form.storeroomCode = storeHouse.storeroomCode
        this.form.storeroomName = storeHouse.storeroomName
        this.form.storeroomType = storeHouse.storeroomType
        this.getMaterialPileList({ reservoirAreaCode: 'FLK', storeroomCode: this.form.storeroomCode }).then((res) => {
          if (res) {
            const temp = res.map((item) => {
              return {
                oilTankCode: item.oilTankCode,
                oilTankName: item.oilTankName
              }
            })
            this.diaOilTankOptions = temp
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form-item-inline {
  display: inline-block;
}
.form-input {
  width: 193px;
}
.form-input-inline,
.form-select-inline {
  width: 180px;
}
.marLeft10 {
  margin-left: 10px;
}
.marRight10 {
  margin-right: 10px;
}
</style>
